<template>
  <div>
    <!-- <el-row :gutter="20">
      <el-col :span="12" :offset="0"></el-col>
      <el-col :span="12" :offset="0"></el-col>
    </el-row> -->

    <el-row :gutter="20" style="text-align: center; margin-bottom: 10px">
      <el-select v-model="valueApp" placeholder="请选择APP名字">
        <el-option
          v-for="item in optionsApp"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select v-model="valueMode" placeholder="请选择APP环境">
        <el-option
          v-for="item in optionsMode"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-input
        v-model="inputVersion"
        placeholder="请输入App版本"
        style="width: 300px"
      ></el-input>
    </el-row>
    <div>
      <uploader
        ref="uploader"
        :options="options"
        :autoStart="false"
        @file-added="onFileAdded"
        @file-success="onFileSuccess"
        @file-progress="onFileProgress"
        @file-error="onFileError"
      >
        <!-- class="uploader-app" -->

        <uploader-unsupport></uploader-unsupport>

        <uploader-btn id="global-uploader-btn" :attrs="attrs" ref="uploadBtn"
          >选择文件</uploader-btn
        >

        <uploader-list v-show="panelShow">
          <div
            class="file-panel"
            slot-scope="props"
            :class="{ collapse: collapse }"
          >
            <div class="file-title">
              <h2>文件列表</h2>
              <div class="operate">
                <el-button
                  @click="fileListShow"
                  type="text"
                  :title="collapse ? '展开' : '折叠'"
                >
                  <i
                    class="iconfont"
                    :class="collapse ? 'inuc-fullscreen' : 'inuc-minus-round'"
                  ></i>
                </el-button>
                <el-button @click="close" type="text" title="关闭">
                  <i class="iconfont icon-close"></i>
                </el-button>
              </div>
            </div>

            <ul class="file-list">
              <li v-for="file in props.fileList" :key="file.id">
                <uploader-file
                  :class="'file_' + file.id"
                  ref="files"
                  :file="file"
                  :list="true"
                ></uploader-file>
              </li>
              <div class="no-file" v-if="!props.fileList.length">
                <i class="iconfont icon-empty-file"></i> 暂无待上传文件
              </div>
            </ul>
          </div>
        </uploader-list>
      </uploader>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { ACCEPT_CONFIG } from "../assets/js/config";
import Bus from "../assets/js/bus";
import SparkMD5 from "spark-md5";

export default {
  data() {
    return {
      inputVersion: "",
      optionsApp: [
        {
          value: "comiru",
          label: "Comiru",
        },
        {
          value: "comiruRecorder",
          label: "Comiru入退室",
        },
        {
          value: "comiruAir",
          label: "ComiruAir",
        },
        {
          value: "comiruim",
          label: "ComiruIM",
        },
        {
          value: "schoolbus",
          label: "スクールバス",
        },
      ],
      optionsMode: [
        {
          value: "stage",
          label: "stage",
        },
        {
          value: "prod",
          label: "本番",
        },
      ],
      valueMode: "",
      valueApp: "",
      //上传文件
      options: {
        // target: api.simpleUploadURL,
        // target: "http://localhost:8000/file/",
        target: "https://distribution.comiru.com/api/file/",
        chunkSize: "2048000",
        fileParameterName: "upfile",
        maxChunkRetries: 1,
        testChunks: true, //是否开启服务器分片校验
        // 服务器分片校验函数，秒传及断点续传基础
        checkChunkUploadedByResponse: function (chunk, message) {
          let objMessage = JSON.parse(message);
          if (objMessage.skipUpload) {
            return true;
          }

          return (objMessage.uploaded || []).indexOf(chunk.offset + 1) >= 0;
        },
        headers: {
          // Authorization: Ticket.get() && "Bearer " + Ticket.get().access_token
        },
        query() {},
      },
      attrs: {
        accept: ACCEPT_CONFIG.getAll(),
      },
      panelShow: false, //选择文件后，展示上传panel
      collapse: false,
    };
  },
  methods: {
    async handleChange(file) {
      const fileObj = file.raw;
      try {
        const buffer = await this.fileToBuffer(fileObj);
        console.log(buffer);
      } catch (e) {
        console.log(e);
      }
    },
    onFileAdded(file) {
      this.panelShow = true;
      this.computeMD5(file);

      Bus.$emit("fileAdded");
    },
    onFileProgress(rootFile, file, chunk) {
      console.log(
        `上传中 ${file.name}，chunk：${chunk.startByte / 1024 / 1024} ~ ${
          chunk.endByte / 1024 / 1024
        }`
      );
    },
    onFileSuccess(rootFile, file, response, chunk) {
      let res = JSON.parse(response);
      console.log("OnFileSuccess");
      console.log(res);
      this.statusSet(file.id, "merging");
      // var api = "http://localhost:8000/merge/";
      var api = "/merge/";
      var data_map = {
        name: res.data.name,
        identifier: file.uniqueIdentifier,
        version: this.inputVersion,
        mode: this.valueMode,
        app_name: this.valueApp,
        // 'length': response.length,
      };
      this.axios
        .get(api, {
          params: data_map,
        })
        .then((response) => {
          console.log(response.data);
          if (response.data.code != 200) {
            this.statusSet(file.id, response.data.message);
          } else Bus.$emit("fileSuccess");
          this.statusRemove(file.id);
        })
        .catch((e) => {
          this.statusSet(file.id, "failed");
        });
      // 服务器自定义的错误（即虽返回200，但是是错误的情况），这种错误是Uploader无法拦截的
      //   if (!res.result) {
      //     this.$message({ message: res.message, type: "error" });
      //     // 文件状态设为“失败”
      //     this.statusSet(file.id, "failed");
      //     return;
      //   }

      // 如果服务端返回需要合并
      //   if (res.needMerge) {
      //     // 文件状态设为“合并中”
      //     this.statusSet(file.id, "merging");

      //     api.mergeSimpleUpload({
      //         tempName: res.tempName,
      //         fileName: file.name,
      //         ...this.params,
      //     }).then(res => {
      //         // 文件合并成功
      //         Bus.$emit('fileSuccess');

      //         this.statusRemove(file.id);
      //     }).catch(e => {});

      //     // 不需要合并
      //   } else {
      //     Bus.$emit("fileSuccess");
      //     console.log("上传成功");
      //   }
    },
    onFileError(rootFile, file, response, chunk) {
      this.$message({
        message: response,
        type: "error",
      });
    },

    /**
     * 计算md5，实现断点续传及秒传
     * @param file
     */
    computeMD5(file) {
      let fileReader = new FileReader();
      let time = new Date().getTime();
      let blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice;
      let currentChunk = 0;
      const chunkSize = 10 * 1024 * 1000;
      let chunks = Math.ceil(file.size / chunkSize);
      let spark = new SparkMD5.ArrayBuffer();

      // 文件状态设为"计算MD5"
      this.statusSet(file.id, "md5");
      file.pause();

      loadNext();

      fileReader.onload = (e) => {
        spark.append(e.target.result);

        if (currentChunk < chunks) {
          currentChunk++;
          loadNext();

          // 实时展示MD5的计算进度
          this.$nextTick(() => {
            $(`.myStatus_${file.id}`).text(
              "校验MD5 " + ((currentChunk / chunks) * 100).toFixed(0) + "%"
            );
          });
        } else {
          let md5 = spark.end();
          this.computeMD5Success(md5, file);
          console.log(
            `MD5计算完毕：${file.name} \nMD5：${md5} \n分片：${chunks} 大小:${
              file.size
            } 用时：${new Date().getTime() - time} ms`
          );
        }
      };

      fileReader.onerror = function () {
        this.error(`文件${file.name}读取出错，请检查该文件`);
        file.cancel();
      };

      function loadNext() {
        let start = currentChunk * chunkSize;
        let end =
          start + chunkSize >= file.size ? file.size : start + chunkSize;

        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
      }
    },

    computeMD5Success(md5, file) {
      // 将自定义参数直接加载uploader实例的opts上
      Object.assign(this.uploader.opts, {
        query: {
          ...this.params,
        },
      });

      file.uniqueIdentifier = md5;
      // file.resume();
      this.statusRemove(file.id);
    },

    fileListShow() {
      let $list = $("#global-uploader .file-list");

      if ($list.is(":visible")) {
        $list.slideUp();
        this.collapse = true;
      } else {
        $list.slideDown();
        this.collapse = false;
      }
    },
    close() {
      this.uploader.cancel();

      this.panelShow = false;
    },

    /**
     * 新增的自定义的状态: 'md5'、'transcoding'、'failed'
     * @param id
     * @param status
     */
    statusSet(id, status) {
      let statusMap = {
        md5: {
          text: "校验MD5",
          bgc: "#fff",
        },
        merging: {
          text: "合并中",
          bgc: "#e2eeff",
        },
        transcoding: {
          text: "转码中",
          bgc: "#e2eeff",
        },
        failed: {
          text: "上传失败",
          bgc: "#e2eeff",
        },
      };

      this.$nextTick(() => {
        $(`<p class="myStatus_${id}"></p>`)
          .appendTo(`.file_${id} .uploader-file-status`)
          .css({
            position: "absolute",
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            zIndex: "1",
            backgroundColor: statusMap[status].bgc,
          })
          .text(statusMap[status].text);
      });
    },
    statusRemove(id) {
      this.$nextTick(() => {
        $(`.myStatus_${id}`).remove();
      });
    },

    error(msg) {
      this.$notify({
        title: "错误",
        message: msg,
        type: "error",
        duration: 2000,
      });
    },
  },
  mounted() {
    Bus.$on("openUploader", (query) => {
      this.params = query || {};

      if (this.$refs.uploadBtn) {
        $("#global-uploader-btn").click();
      }
    });
  },
  computed: {
    //Uploader实例
    uploader() {
      return this.$refs.uploader.uploader;
    },
  },
  destroyed() {
    Bus.$off("openUploader");
  },
};
</script>

<style>
.uploader-example {
  width: 880px;
  padding: 15px;
  margin: 40px auto 0;
  font-size: 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
}
.uploader-example .uploader-btn {
  margin-right: 4px;
}
.uploader-example .uploader-list {
  max-height: 440px;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>